import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ShelfAddTitleButton from '../ShelfAddTitleButton';

import './ShelfTitleBar.scss';

export default function ShelfTitleBar({ owner, shelfActions, currentShelfName, currentUserShelves }) {
  if (owner.get('loggedIn')) {
    return (
      <div className="cp-shelf-title-bar">
        <ShelfAddTitleButton
          shelfActions={shelfActions}
          currentShelfName={currentShelfName}
          currentUserShelves={currentUserShelves}
          ownerId={owner.get('id')} />
      </div>
    );
  }

  return null;
}

ShelfTitleBar.propTypes = {
  owner: ImmutablePropTypes.map.isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  currentShelfName: PropTypes.string.isRequired,
  currentUserShelves: ImmutablePropTypes.map.isRequired
};



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfTitleBar/ShelfTitleBar.jsx